function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#WAX_svg__clip0_1_132)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 29.4c8.286 0 15-6.445 15-14.4S23.286.6 15 .6 0 7.045 0 15c0 7.954 6.714 14.4 15 14.4z",
  fill: "#F89022"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.474 18.332H24.26l-1.572-1.292-1.566 1.286H19.25l-.897-1.046h-3.088l.78-.925h1.517L16.406 15l-4.035 4.718H10.5l1.168-1.37H9.72L8.668 15.51l-1.046 2.816H5.635l-1.66-4.42H5.49l1.118 3.012 1.112-2.997h1.877l1.112 2.992 1.113-2.992h1.516l-1.677 4.432.371-.436 3.426-4.001h1.882l2.85 3.337 1.374-1.132-4.334-3.597h2.225l7.018 5.808zm-2.203-2.678l-1.046-.861 1.04-.856h2.11l-2.104 1.717z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "WAX_svg__clip0_1_132"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgWax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "f24b680ec63a6bce15bc874f9f958cc7.svg";
export { SvgWax as ReactComponent };